import { toast } from 'react-toastify';
import { all, call, fork, put, takeLeading } from 'redux-saga/effects';

import { saveSystemMaintenance, fetchSystemMaintenance } from '../../../../services/systemMaintenance';
import { fetchSystemMaintenanceSuccessful, saveSystemMaintenanceStarted, saveSystemMaintenanceSuccessful } from './actions';
import { SystemMaintenanceDB, SystemMaintenanceTypes } from './types';

export function* attemptSaveSystemMaintenance({ payload }: ReturnType<typeof saveSystemMaintenanceStarted>) {
    try {
        const systemMaintenance: SystemMaintenanceDB[] = yield call(saveSystemMaintenance, payload);
        yield put(saveSystemMaintenanceSuccessful(systemMaintenance));
    } catch (e) {
        toast.error('Unable to save. Please try again.');
    }
}

function* saveSystemMaintenanceWatcher() {
    yield takeLeading(SystemMaintenanceTypes.SAVE_SYSTEM_MAINTENANCE_STARTED, attemptSaveSystemMaintenance);
}

export function* attemptFetchSystemMaintenance() {
    try {
        const systemMaintenance: SystemMaintenanceDB[] = yield call(fetchSystemMaintenance);
        yield put(fetchSystemMaintenanceSuccessful(systemMaintenance));
    } catch (e) {
        toast.error('Unable to fetch. Please try again.');
    }
}

function* fetchSystemMaintenanceWatcher() {
    yield takeLeading(SystemMaintenanceTypes.FETCH_SYSTEM_MAINTENANCE_STARTED, attemptFetchSystemMaintenance);
}

export function* systemMaintenanceSaga() {
    yield all([
        fork(saveSystemMaintenanceWatcher),
        fork(fetchSystemMaintenanceWatcher)
    ]);
}
